// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.i-layout-content-main[data-v-2469e06a]{\n        margin-left: 12px;\n        margin-right: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
